import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document } from '@contentful/rich-text-types';
import { UtilityService } from '../services/utility';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

export const RichText: React.FC<{content: Document, additionalClass?: string}> = ({content, additionalClass = null}) => {
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node: any, next: any) => `<img class="rounded" alt="${node.data.target.fields.title}" src="${node.data.target.fields.file.url}"/>`,
      [INLINES.ENTRY_HYPERLINK]: (node: any, next: any) => `<a href="${next(node.data.target.fields.slug)}">test</a>`,
    },
  };

  const renderedContent = documentToHtmlString(content, options);
  return <div className={`richtext ${additionalClass}`} dangerouslySetInnerHTML={UtilityService.parseRichText(renderedContent)} />;
};
